import Map from "./Map";
import { useJsApiLoader } from "@react-google-maps/api";

/**
 * BodyLocations component for German locale
 * Displays Google Maps with Hertz 24/7 locations
 */
function CHFrBodyLocations() {
  const strGMK =
    window._env_?.REACT_APP_GOOGLE_MAPS_API_KEY ||
    process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

  const { isLoaded, loadError } = useJsApiLoader({
    id: strGMK || "fallback",
    googleMapsApiKey: strGMK || "",
  });

  if (!strGMK) {
    return (
      <div className="container-fluid body-font">
        <div className="alert alert-warning" role="alert">
          <strong>Carte indisponible</strong> - Configuration manquante.
          Veuillez contacter le support.
        </div>
      </div>
    );
  }

  if (loadError) {
    return (
      <div className="container-fluid body-font">
        <div className="alert alert-danger" role="alert">
          <strong>Carte indisponible</strong> - Échec du chargement de Google
          Maps. Veuillez réessayer plus tard.
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="container-fluid body-font">
        <div className="row">
          <div className="col-xs-12 col-md-6 py-md-5">
            <p className="h6">
              <b>Sites</b>
            </p>
            <p className="h1">
              <b>Toujours à proximité</b>
            </p>
            <p>
              Avec plus de 700 sites en Europe, il y a toujours un véhicule
              Hertz 24/7® près de chez vous. Trouvez votre véhicule le plus
              proche à l’aide de cette carte.
            </p>
          </div>
        </div>
        <Map isLoaded={isLoaded} />
        <div className="row">
          <div className="col-xs-12 py-md-5" style={{ textAlign: "left" }}>
            <h1 className="display-5">
              <b>Nos implantations</b>
            </h1>
            <p>
              Avec plus de 700 sites à travers l'Europe, une voiture ou un
              utilitaire Hertz 24/7® est plus proche que vous ne le pensez.
            </p>
            <div className="row">
              <div
                className="col-xs-12 col-md-4 "
                style={{ textAlign: "left" }}
              >
                <p>
                  <b>Royaume-Uni (300 Localisation des sites)</b>
                </p>
                <p>
                  <a
                    href="https://booking.hertz247.com/booking/book?location=prk-gb13121600020009&product=HOURLY_RENTAL"
                    style={{ textDecoration: "none" }}
                  >
                    Manchester
                  </a>
                </p>
                <p>
                  <a
                    href="https://booking.hertz247.com/booking/book?location=prk-gb11082902024006&product=HOURLY_RENTAL"
                    style={{ textDecoration: "none" }}
                  >
                    London
                  </a>
                </p>
              </div>
              <div
                className="col-xs-12 col-md-4 "
                style={{ textAlign: "left" }}
              >
                <p>
                  <b>France (20 Localisation des sites)</b>
                </p>
                <p>
                  <a
                    href="https://booking.hertz247.com/booking/book?location=prk-fr19100400001005&product=HOURLY_RENTAL"
                    style={{ textDecoration: "none" }}
                  >
                    Paris
                  </a>
                </p>
                <p>
                  <a
                    href="https://booking.hertz247.com/booking/book?location=prk-fr19110500007004&product=HOURLY_RENTAL"
                    style={{ textDecoration: "none" }}
                  >
                    Marseilles
                  </a>
                </p>
              </div>
              <div
                className="col-xs-12 col-md-4 "
                style={{ textAlign: "left" }}
              >
                <p>
                  <b>Allemagne (280 Localisation des sites)</b>
                </p>
                <p>
                  <a
                    href="https://booking.hertz247.com/booking/book?location=prk-de18112800001004&product=HOURLY_RENTAL"
                    style={{ textDecoration: "none" }}
                  >
                    Berlin
                  </a>
                </p>
                <p>
                  <a
                    href="https://booking.hertz247.com/booking/book?location=prk-de15102900001000&product=HOURLY_RENTAL"
                    style={{ textDecoration: "none" }}
                  >
                    Frankfurt
                  </a>
                </p>
              </div>
              <div
                className="col-xs-12 col-md-4 "
                style={{ textAlign: "left" }}
              >
                <p>
                  <b>Italie (75 Localisation des sites)</b>
                </p>
                <p>
                  <a
                    href="https://booking.hertz247.com/booking/book?location=prk-it17072800007000&product=HOURLY_RENTAL"
                    style={{ textDecoration: "none" }}
                  >
                    Rome
                  </a>
                </p>
                <p>
                  <a
                    href="https://booking.hertz247.com/booking/book?location=prk-it17072800005002&product=HOURLY_RENTAL"
                    style={{ textDecoration: "none" }}
                  >
                    Milan
                  </a>
                </p>
              </div>
              <div
                className="col-xs-12 col-md-4 "
                style={{ textAlign: "left" }}
              >
                <p>
                  <b>Portugal (39 Localisation des sites)</b>
                </p>
                <p>
                  <a
                    href="https://booking.hertz247.com/booking/book?location=prk-pt21051200001008&product=HOURLY_RENTAL"
                    style={{ textDecoration: "none" }}
                  >
                    Lisbon
                  </a>
                </p>
                <p>
                  <a
                    href="https://booking.hertz247.com/booking/book?location=prk-pt17062200003001&product=HOURLY_RENTAL"
                    style={{ textDecoration: "none" }}
                  >
                    Porto
                  </a>
                </p>
              </div>
              <div
                className="col-xs-12 col-md-4 "
                style={{ textAlign: "left" }}
              >
                <p>
                  <b>Suisse (4 Localisation des sites)</b>
                </p>
                <p>
                  <a
                    href="https://booking.hertz247.com/booking/book?location=prk-chCHHZBRN&product=HOURLY_RENTAL"
                    style={{ textDecoration: "none" }}
                  >
                    Bern
                  </a>
                </p>
                <p>
                  <a
                    href="https://booking.hertz247.com/booking/book?location=prk-chCHHZLUG&product=HOURLY_RENTAL"
                    style={{ textDecoration: "none" }}
                  >
                    Lugano
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="row shadow-lg p-3 mb-5 bg-body rounded">
          <a href="https:/l.ead.me/beWm77">
            <img
              className="img-fluid rounded-4"
              src="https://images.hertz.com/content/dam/hod/images/en-gb/static/LocationBannerFR.png"
              alt=""
              style={{
                width: "100vw",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
              }}
            />
          </a>
        </div>
      </div>
    </>
  );
}
export default CHFrBodyLocations;
